// extracted by mini-css-extract-plugin
export default {"priceBox":"RenewPriceWithOption-priceBox_b2M_J"};